import React from "react";
import { RolePermissionForm } from "./RolePermissionForm";

// Add Role opens as a side panel over the Roles list (expandable to a full
// view). It shares its layout and permission logic with Edit Role -- see
// RolePermissionForm.js.
export const CreatePermissionRole = ({ onClose, onSaved }) => (
  <RolePermissionForm mode="create" variant="panel" onClose={onClose} onSaved={onSaved} />
);
